const AGENST = {
  AGENT_LIST_TITLE: "Agents",
  SEARCH_IN_AGENTS: "Search in agents",
};

export default AGENST;
